// components/apps/index.js
// example export { default as BaseAvatar } from './BaseAvatar';
export { default as Quiz } from './Quiz';
export { default as FictionaryItem } from './FictionaryItem';
